import type { WorkspaceLogEntry } from "../types";

export const formatLogEntry = (log: WorkspaceLogEntry): string => {
  const details =
    log.details === undefined ? "" : ` ${JSON.stringify(log.details)}`;
  return `${log.level.toUpperCase()} ${log.message}${details}`;
};
